import React, { useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { NavLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import MiratsLogo from '../../../../assets/MiratsLogo.svg';
import { CgTemplate } from 'react-icons/cg';
import { TbReportAnalytics } from 'react-icons/tb';
import { MdOutlineBallot, MdOutlineSecurity } from 'react-icons/md';
import { AiOutlineReconciliation } from 'react-icons/ai';
import { IoDocumentsOutline } from 'react-icons/io5';
import { RiQuestionAnswerLine } from 'react-icons/ri';
import { BsDatabaseSlash } from 'react-icons/bs';
import { TbAdjustmentsCheck } from 'react-icons/tb';
import {
  MdOutlineNotificationsActive,
  MdOutlineHelpCenter,
} from 'react-icons/md';
//
const SurveySidebar = ({ children }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [collapse, setCollapse] = useState(false);

  const SideBarData = [
    {
      name: 'Details',
      path: `/surveys/${id}/details`,
      subPath: 'details',
      icon: <CgTemplate size={23} />,
    },
    {
      name: 'Qualification',
      path: `/surveys/${id}/qualification`,
      subPath: 'qualification',
      icon: <MdOutlineHelpCenter size={23} />,
    },
    {
      name: 'Quotas',
      path: `/surveys/${id}/quotas`,
      subPath: 'quotas',
      icon: <TbAdjustmentsCheck size={23} />,
    },
    {
      name: 'Allocations',
      path: `/surveys/${id}/allocations`,
      subPath: 'allocations',
      icon: <MdOutlineBallot size={23} />,
    },
    {
      name: 'Reports',
      path: `/surveys/${id}/reports`,
      subPath: 'reports',
      icon: <TbReportAnalytics size={23} />,
    },
    {
      name: 'Reconciliation',
      path: `/surveys/${id}/reconciliation`,
      subPath: 'reconciliation',
      icon: <AiOutlineReconciliation size={23} />,
    },
    {
      name: 'Security',
      path: `/surveys/${id}/security`,
      subPath: 'security',
      icon: <MdOutlineSecurity size={23} />,
    },
    // {
    //   name: "Documents",
    //   path: `/surveys/${id}/documents`,
    //   subPath: "documents",
    //   icon: <IoDocumentsOutline size={23} />,
    // },
    {
      name: 'Resp. Answers',
      path: `/surveys/${id}/respondent-answers`,
      subPath: 'respondent-answers',
      icon: <RiQuestionAnswerLine size={23} />,
    },
    // {
    //   name: "Termination Data",
    //   path: `/surveys/${id}/termination-data`,
    //   subPath: "termination-data",
    //   icon: <BsDatabaseSlash size={23} />,
    // },
  ];

  return (
    <div className="w-full flex" style={{ height: 'calc(100vh - 64px)' }}>
      <div
        className={`
        ${collapse ? 'w-[70px]' : 'w-[280px]'}
        transition-all duration-300 ease-in-out bg-white z-[20] border-r border-gray-200 shadow-sm relative flex flex-col`}
      >
        {/* Collapse/Expand Button */}
        <button
          className={`absolute top-10 right-[-16px] w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer bg-[#0226BE] hover:bg-[#021ea8] shadow-md z-10 ${
            collapse ? '' : ''
          }`}
          onClick={(e) => setCollapse(!collapse)}
          title={collapse ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapse ? (
            <IoIosArrowForward color="white" size={18} />
          ) : (
            <IoIosArrowBack color="white" size={18} />
          )}
        </button>

        {/* Navigation Items */}
        <div className="flex-1 overflow-y-auto containerScroll py-4 px-3">
          <nav className="flex flex-col gap-1">
            {SideBarData?.map((data, ind) => {
              const isActive = location.pathname?.includes(data?.subPath);
              return (
                <button
                  key={ind}
                  onClick={(e) => navigate(data?.path)}
                  className={`
                    group relative flex items-center transition-all duration-200 rounded-lg
                    ${collapse ? 'justify-center px-2 py-3' : 'px-4 py-3 gap-3'}
                    ${
                      isActive
                        ? 'bg-blue-50 text-[#0226BE] font-[600]'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-[#0226BE] font-[500]'
                    }
                  `}
                  title={collapse ? data?.name : ''}
                >
                  {/* Active indicator */}
                  {isActive && !collapse && (
                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#0226BE] rounded-r-full"></div>
                  )}

                  {/* Icon */}
                  <div
                    className={`
                      flex-shrink-0 transition-colors
                      ${isActive ? 'text-[#0226BE]' : 'text-gray-500 group-hover:text-[#0226BE]'}
                    `}
                  >
                    {React.cloneElement(data?.icon, {
                      size: collapse ? 22 : 20,
                    })}
                  </div>

                  {/* Text */}
                  {!collapse && (
                    <span
                      className={`
                        text-[14px] whitespace-nowrap transition-all duration-300
                        ${isActive ? 'font-[600]' : 'font-[500]'}
                      `}
                    >
                      {data?.name}
                    </span>
                  )}
                </button>
              );
            })}
          </nav>
        </div>
      </div>
      <div
        className="transition-all duration-300 ease-in-out flex items-start justify-center overflow-y-auto containerScroll bg-gray-50"
        style={{
          width: collapse ? 'calc(100% - 70px)' : 'calc(100% - 280px)',
          height: 'calc(100vh - 64px)',
        }}
      >
        <div className="w-full max-w-[1600px] px-6 py-8">{children}</div>
      </div>
    </div>
  );
};

export default SurveySidebar;
